type Props = {
  tagName: string;
};

export function TagSmall(props: Props) {
  const { tagName } = props;

  return (
    <div
      className='inline-flex min-h-6 items-center justify-center gap-3 rounded-[78px] bg-azure-595/10 px-3 py-1.5'
      // style="display: inline-flex !important; min-height: 1.5rem !important; align-items: center !important; justify-content: center !important; gap: 0.75rem !important; border-radius: 78px !important; background-color: rgba(5, 135, 251, 0.1) !important; padding: 0.375rem 0.75rem !important; margin: 0 !important;"
    >
      <p
        className='text-center font-["Poppins"] text-xs leading-3 font-semibold text-azure-595'
        // style="text-align: center !important; font-family: 'Poppins' !important; font-size: 0.75rem !important; font-weight: 600 !important; line-height: 0.75rem !important; color: #0587FB !important; margin: 0 !important; text-decoration: none !important;"
      >
        {tagName}
      </p>
    </div>
  );
}
